<template>
  <div id="app">
    <div class="container">
      <div class="logo"><img src="./assets/img/logo.png"></div>
      <router-view/>
    </div>
    <div class="footer">
      <ul class="container">
        <li><a :href="search"><i class="icon-1"></i><span>专利检索分析应用平台</span></a></li>
        <li>
          <router-link to="/news"><i class="icon-2"></i><span>高校知识产权资讯简报</span></router-link>
        </li>
        <li><a :href="infoCenter"><i class="icon-3"></i><span>深圳大学知识产权信息服务中心</span>
        </a></li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    const config = window.APP_CONFIG.LINK
    return {
      search: config.SEARCH,
      infoCenter: config.INFO_CENTER,
      isMobile: false
    }
  },
  mounted() {
    // 判断是否移动端
    this.isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    if(this.isMobile){
      let body = document.getElementsByTagName('body')[0]
      body.classList.add('mobile-set')
    }
  }
}
</script>
